<div class="container-post" *ngIf="arrayNew">
  <div *ngFor="let block of arrayNew.content">
    <div class="section-divisor" [ngSwitch]="block.type">
      <div
        [ngStyle]="{
          'background-image':
            'url(' + env.origin + '/blogmidias/' + block.data.src + ')'
        }"
        class="banner"
        *ngSwitchCase="'banner'"
      ></div>
      <div class="container">
        <div class="container-img" *ngSwitchCase="'imagem'">
          <img
            class="block-imagem"
            [src]="env.origin + '/blogmidias/' + block.data.src"
            [alt]="block.data.alt"
          />
        </div>
        <div
          class="block-text"
          *ngSwitchCase="'texto'"
          [innerHTML]="block.data"
        ></div>

        <div
          class="citacao"
          *ngSwitchCase="'citação'"
          [innerHTML]="block.data"
        ></div>
      </div>
  
    </div>
  </div>
  <div class="social-midias">
    <div class="container-json">
      <h4><strong>Não quer perder nenhuma dica da azulzinha?</strong></h4>
      <p>
        Navegue pelo <strong><a target="_blank" href="https://www.azulzinhadacaixa.com.br/">site</a></strong> e siga nossas
        redes sociais
      </p>
      <div class="container-social-midias">
        <div>
          <a class="box-midia" target="_blank" href="https://www.instagram.com/azulzinhadacaixa/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D">
            <img src="assets/img/icons/instagram.png" alt="" />
            <span>Instagram</span>
          </a>
        </div>
        <div>
          <a class="box-midia" target="_blank" href="https://www.facebook.com/azulzinhadacaixa">
            <img src="assets/img/icons/facebook.png" alt="" />
            <span>Facebook</span>
          </a>
        </div>
        <div>
          <a class="box-midia" target="_blank" href="https://www.linkedin.com/company/azulzinhadacaixa/">
            <img src="assets/img/icons/linkedin.png" alt="" />
            <span>LinkedIn</span>
          </a>
        </div>
        <div class="box-youtube">
          <a class="box-midia" target="_blank" href="https://www.youtube.com/@azulzinhadaCAIXA">
            <img src="assets/img/icons/youtube.png" alt="" />
            <span>YouTube</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-latest-post *ngIf="data.length > 0" [posts]="data"></app-latest-post>
</div>
